import FuseUtils from "@fuse/FuseUtils";
import _ from "@lodash";
import themesConfig from "app/Configs/fuse-configs/themesConfig";
import * as userActions from "app/Core/Funcionalidade/Auth/store/actions";
import * as Helpers from "app/Core/Helpers";
import { setInitialSettings } from "app/store/actions";
import axios from "axios";
import Constante from "Constante.json";
import * as firebase from "firebase/app";
import "firebase/auth";
import FirebaseConfig from "FirebaseConfig.json";

class FirebaseAuthService extends FuseUtils.EventEmitter {

    initializeFirebase = async () => {
        if (_.isObject(firebase) && (firebase.apps.length < 1 || !_.isObject(firebase.app()))) {
            firebase.initializeApp(FirebaseConfig[document.location.host]);
        }
    };

    getAccessToken = () => {
        const access_token = window.sessionStorage.getItem("jwt_access_token");
        return access_token;
    };

    getTheme = (_ATheme) => {
        var ATheme = themesConfig;
        var ATema = "azul_claro";

        if (!_.isUndefined(_ATheme) && !_.isNull(_ATheme) && _ATheme !== "") {
            ATema = _ATheme;
        }

        return ATheme[ATema];
    };

    setSession = (access_token, _AUser, _ALogin, _ADisplayName, _ATheme, _AType) => {
        if (access_token) {
            sessionStorage.setItem("jwt_access_token", access_token);
            sessionStorage.setItem("username", _AUser);
            sessionStorage.setItem("login", _ALogin);
            sessionStorage.setItem("displayname", _ADisplayName);
            sessionStorage.setItem("theme", _ATheme);
            sessionStorage.setItem("themetype", _AType);
            axios.defaults.headers.common["Authorization"] = "Bearer " + this.getAccessToken();
        }
        else {
            this.Logout();
        }
    };

    Register = async (_AForm) => {
        await this.initializeFirebase();
        var AClass = this;
        try {
            return new Promise((resolve, reject) => {
                firebase.auth().createUserWithEmailAndPassword(_AForm.email, _AForm.password)
                    .then(() => {
                        var user = firebase.auth().currentUser;
                        sessionStorage.setItem("username", user.uid);
                        user.sendEmailVerification()
                            .then(() => {
                                resolve({ ..._AForm, uid: user.uid, idprojeto: FirebaseConfig[document.location.host].projectId });
                            })
                            .catch((error) => {
                                reject({ variant: "error", message: AClass.getMessageFirebaseErro(error) });
                            });
                    })
                    .catch(function (error) {
                        reject({ variant: "error", message: AClass.getMessageFirebaseErro(error) });
                    });
            });
        }
        catch (error) {
            alert("Erro ao efetuar requisição, verifique a compatibilidade de versão do seu browser com o sistema ou entre em contato com o administrador do sistema.");
        }
    };

    Delete = () => {
        var user = firebase.auth().currentUser;
        user.delete().then(function () { }).catch(function () { });
    };

    async getToken() {
        return await firebase.auth().currentUser.getIdToken();
    }

    Login = async (_AForm) => {
        await this.initializeFirebase();
        var AClass = this;
        try {
            return new Promise((resolve, reject) => {
                if (_AForm.username === undefined || _AForm.password === undefined || _AForm.username.length < 3 || _AForm.password.length < 3) {
                    reject({ variant: "error", message: "Comprimento inválido para usuário ou senha" });
                }
                firebase.auth().signInWithEmailAndPassword(_AForm.username, _AForm.password)
                    .then((resp) => {
                        sessionStorage.setItem("username", resp.user.uid);
                        if (!resp.user.emailVerified) {
                            reject({ variant: "warning", message: "Email não verificado, por favor verifique sua caixa postal e ative sua conta!" });
                        }
                        else {
                            Promise.all([
                                this.getToken()
                            ]).then((_AToken) => {
                                sessionStorage.setItem("google_access_token", _AToken[0]);
                                sessionStorage.setItem("recaptcha", _AForm.recaptcha);
                                resolve(_AToken);
                            });
                        }
                    })
                    .catch((error) => {
                        reject({ variant: "error", message: AClass.getMessageFirebaseErro(error) });
                    });
            });
        }
        catch (error) {
            alert("Erro ao efetuar requisição, verifique a compatibilidade de versão do seu browser com o sistema ou entre em contato com o administrador do sistema.");
        }
    };

    ReenviarEmail = (_AForm) => {
        try {
            return new Promise((resolve, reject) => {
                var user = firebase.auth().currentUser;
                user.sendEmailVerification()
                    .then(() => {
                        resolve({ variant: "success", message: "Solicitação de verificação enviada para o email:" + _AForm.username });
                    })
                    .catch((error) => {
                        reject({ variant: "error", message: error.message });
                    });
            });
        }
        catch (error) {
            alert("Erro ao efetuar requisição, verifique a compatibilidade de versão do seu browser com o sistema ou entre em contato com o administrador do sistema.");
        }
    };

    Logout = async () => {
        await this.initializeFirebase();
        Helpers.SetPreload(false);
        firebase.auth().signOut().then(function () {
            sessionStorage.removeItem("jwt_access_token");
            sessionStorage.removeItem("google_access_token");
            sessionStorage.removeItem("recaptcha");
            sessionStorage.removeItem("username");
            sessionStorage.removeItem("login");
            sessionStorage.removeItem("displayname");
            sessionStorage.removeItem("CriarTeste");
            sessionStorage.removeItem("organizacao");
            delete axios.defaults.headers.common["Authorization"];
            setInitialSettings();
            firebase.app().delete();
            Helpers.checkRedirectAuth();
        }).catch(function (error) {
            console.log(error);
        }).finally(() => {
            Helpers.SetPreload(false);
        });
    };

    resetPassword = async (_AEmail) => {
        await this.initializeFirebase();
        try {
            return new Promise((resolve, reject) => {
                firebase.auth().sendPasswordResetEmail(_AEmail, { url: document.location.origin })
                    .then(() => {
                        resolve({ variant: "success", message: "Email enviado para: " + _AEmail });
                    })
                    .catch(() => {
                        reject({ variant: "error", message: "Email inválido" });
                    });
            });
        }
        catch (error) {
            alert("Erro ao efetuar requisição, verifique a compatibilidade de versão do seu browser com o sistema ou entre em contato com o administrador do sistema.");
        }
    };

    signInWithFirebase = () => {
        try {
            return new Promise((resolve, reject) => {
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                fetch("/Auth/", {
                    method: "post",
                    headers: myHeaders,
                    body: JSON.stringify({
                        "GoogleToken": sessionStorage.getItem("google_access_token"),
                        "Recaptcha": sessionStorage.getItem("recaptcha"),
                        "Contexto": sessionStorage.getItem("ctx"),
                        "CriarTeste": sessionStorage.getItem("CriarTeste"),
                        "Login": sessionStorage.getItem("username"),
                        "Organizacao": sessionStorage.getItem("organizacao"),
                        "VersaoUI": Constante.versao,
                        "UrlUI": document.location.origin
                    }),
                }).then(resp => {
                    if (resp.status === 500) {
                        console.log(resp.statusText);
                        resp.json().then(response => {
                            if (response?.error && response.error.includes("reCAPTCHA")) {
                                reject(response.error);
                                window.setTimeout(() => window.location.reload(), 1500);
                            }
                            else {
                                reject("Erro ao efetuar operação, informe o administrador do sistema");
                            }
                        }).catch(erro => {
                            reject("Erro ao efetuar operação, informe o administrador do sistema");
                        });
                    }
                    else {
                        resp.json().then(response => {
                            if (response.error !== null && response.error !== "") {
                                try {
                                    var AJson = JSON.parse(response.error);
                                    console.log(AJson);
                                    reject("Erro ao efetuar operação, informe o administrador do sistema");
                                } catch (e) {
                                    reject(response.error);
                                }
                            }
                            else if (!_.isNull(response.organizacoes) && response.organizacoes.length > 0 &&
                                response.organizacoes[0].url_ui !== window.location.origin && window.location.pathname === "/pub-login") {
                                resolve(response);
                            }
                            else {
                                this.setSession(response.access_token,
                                    response.user.data.username,
                                    response.user.data.login,
                                    response.user.data.displayName,
                                    !_.isNull(response.user.data.settings) ? this.getTheme(response.user.data.settings.theme).palette.primary.main : null,
                                    !_.isNull(response.user.data.settings) ? this.getTheme(response.user.data.settings.theme).palette.type : null,
                                    !_.isUndefined(window.CONTEXTO) ? window.CONTEXTO.tipo : null
                                );
                                resolve(response);
                            }
                        }).catch(error => {
                            var AJsonErro = JSON.parse(error);
                            reject(AJsonErro.message);
                        });
                    }
                }).catch(error => {
                    var AJsonErro = JSON.parse(error);
                    reject(AJsonErro.message);
                });
            });
        }
        catch (error) {
            alert("Erro ao efetuar requisição, verifique a compatibilidade de versão do seu browser com o sistema ou entre em contato com o administrador do sistema.");
        }
    };

    signInWithToken = () => {
        var ARota = "/Auth/";
        try {
            return new Promise((resolve, reject) => {
                this.fetchGet(ARota)
                    .then(resp => {
                        if (resp.status === 403) {
                            console.log(resp);
                            reject("Erro ao efetuar operação, informe o administrador do sistema");
                        }
                        else {
                            resolve(resp);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        reject("Erro ao efetuar operação, informe o administrador do sistema");

                    });
            });
        }
        catch (error) {
            alert("Erro ao efetuar requisição, verifique a compatibilidade de versão do seu browser com o sistema ou entre em contato com o administrador do sistema.");
        }
    };

    CheckGoogleToken = () => {
        try {
            var url = Helpers.ReplaceAll("https://www.googleapis.com/oauth2/v1/tokeninfo?access_token=TOKEN", "TOKEN", sessionStorage.getItem("google_access_token"));
            return new Promise((resolve, reject) => {
                axios.get(url).then(response => {
                    if (response.status === 200) {
                        resolve(response);
                    }
                    else {
                        reject(response);
                    }
                })
                    .catch(error => {
                        reject(error);
                    });
            });
        }
        catch (error) {
            alert("Erro ao efetuar requisição, verifique a compatibilidade de versão do seu browser com o sistema ou entre em contato com o administrador do sistema.");
        }
    };

    reauthenticatefirebase = () => {
        var user = firebase.auth().currentUser;
        var credential;
        user.reauthenticateWithCredential(credential).then(function () { }).catch(function () { });
    };

    getNewFirebaseToken = () => {
        try {
            return new Promise((resolve) => {
                resolve("ok");
            });
        }
        catch (error) {
            alert("Erro ao efetuar requisição, verifique a compatibilidade de versão do seu browser com o sistema ou entre em contato com o administrador do sistema.");
        }
    };

    validateResponse = () => {
        try {
            return new Promise((resolve, reject) => {
                this.getNewFirebaseToken()
                    .then(() => this.signInWithFirebase()
                        .then(user => {
                            userActions.setUserData(user);

                        })
                        .then(() => resolve("Reautenticado"))
                        .catch(error => {
                            //this.Logout();
                            reject(error);
                        })
                    );
            });
        }
        catch (error) {
            alert("Erro ao efetuar requisição, verifique a compatibilidade de versão do seu browser com o sistema ou entre em contato com o administrador do sistema.");
        }
    };

    fetchPost = (_ARota, _AOrganizacao, _AEmpresa, _AMethod, _AActions, _AProcedure = "") => {
        try {
            return new Promise((resolve, reject) => {
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append("Authorization", "Bearer " + this.getAccessToken());
                fetch(_ARota, {
                    method: "post",
                    headers: myHeaders,
                    body: JSON.stringify({
                        "Organizacao": _AOrganizacao,
                        "Empresa": _AEmpresa,
                        "Usuario": sessionStorage.getItem("username"),
                        "Method": _AMethod,
                        "Actions": _AActions,
                        "Procedure": _AProcedure,
                        "PathName": document.location.pathname
                    }),
                }).then(resp => {
                    if (resp.status === 403) {
                        this.validateResponse()
                            .then((resp) => {
                                resolve(resp);
                            })
                            .catch(error => {
                                reject(error);
                            });
                    }
                    else if (resp.status === 404) {
                        reject("Recurso não localizado, informe o administrador do sistema.");
                    }
                    else if (resp.status === 504) {
                        reject("Erro ao conectar servidor, verifique sua conexão com a internet!");
                    }
                    else {
                        resp.json().then(response => {
                            if ((response.error) && (response.error.length > 0)) {
                                try {
                                    var AJson = JSON.parse(response.error);
                                    console.log(AJson);
                                    reject("Erro ao efetuar operação, informe o administrador do sistema");
                                } catch (e) {
                                    reject(response.error);
                                }
                            }
                            else {
                                resolve(response);
                            }
                        });
                    }
                }).catch(error => {
                    if (error.response.status === 403) {
                        this.validateResponse()
                            .then(() => {
                                resolve("Reautenticado");
                            })
                            .catch(error => {
                                reject(error);
                            });
                    }
                    else if (error.response.status === 500) {
                        console.log(error);
                        reject("Erro ao efetuar operação, informe o administrador do sistema");

                    }
                    else {
                        var AJsonErro = JSON.parse(error);
                        reject(AJsonErro.message);
                    }

                });
            });
        }
        catch (error) {
            alert("Erro ao efetuar requisição, verifique a compatibilidade de versão do seu browser com o sistema ou entre em contato com o administrador do sistema.");
        }
    };

    fetchGet = (_ARota) => {
        try {
            return new Promise((resolve, reject) => {
                var myHeaders = new Headers();
                myHeaders.append("Authorization", "Bearer " + this.getAccessToken());
                myHeaders.append("GoogleToken", sessionStorage.getItem("google_access_token"));
                myHeaders.append("Recaptcha", sessionStorage.getItem("recaptcha"));
                myHeaders.append("VersaoUI", Constante.versao);
                myHeaders.append("UrlUI", document.location.origin);

                if (!_.isUndefined(sessionStorage.getItem("organizacao")) && !_.isNull(sessionStorage.getItem("organizacao")))
                    myHeaders.append("Organizacao", sessionStorage.getItem("organizacao"));

                if (!_.isUndefined(sessionStorage.getItem("ctx")) && !_.isNull(sessionStorage.getItem("ctx")))
                    myHeaders.append("Contexto", sessionStorage.getItem("ctx"));

                if (!_.isUndefined(sessionStorage.getItem("ctxtipo")) && !_.isNull(sessionStorage.getItem("ctxtipo")))
                    myHeaders.append("ContextoTipo", sessionStorage.getItem("ctxtipo"));

                if (!_.isUndefined(sessionStorage.getItem("CriarTeste")) && !_.isNull(sessionStorage.getItem("CriarTeste")))
                    myHeaders.append("CriarTeste", sessionStorage.getItem("CriarTeste"));

                fetch(_ARota, {
                    method: "get",
                    headers: myHeaders,
                }).then(resp => {
                    if (resp.status === 403) {
                        this.validateResponse()
                            .then((resp) => {
                                resolve(resp);
                            })
                            .catch(error => {
                                reject(error);
                            });
                    }
                    else if (resp.status === 504) {
                        reject("Erro ao conectar servidor, verifique sua conexão com a internet!");
                    }
                    else {
                        resp.json().then(response => {
                            if ((response.error) && (response.error.length > 0)) {
                                try {
                                    var AJson = JSON.parse(response.error);
                                    console.log(AJson);
                                    reject("Erro ao efetuar operação, informe o administrador do sistema");
                                } catch (e) {
                                    reject(response.error);
                                }
                            }
                            else {
                                resolve(response);
                            }
                        });
                    }
                }).catch(error => {
                    if (error.response.status === 403) {
                        this.validateResponse()
                            .then(() => {
                                resolve("Reautenticado");
                            })
                            .catch(error => {
                                reject(error);
                            });
                    }
                    else if (error.response.status === 500) {
                        console.log(error);
                        reject("Erro ao efetuar operação, informe o administrador do sistema");

                    }
                    else {
                        var AJsonErro = JSON.parse(error);
                        reject(AJsonErro.message);
                    }
                });
            });
        }
        catch (error) {
            alert("Erro ao efetuar requisição, verifique a compatibilidade de versão do seu browser com o sistema ou entre em contato com o administrador do sistema.");
        }
    };

    getMessageFirebaseErro = (error) => {
        console.log(error.code);
        switch (error.code) { //
            case "auth/email-already-in-use": return "Este e-mail encontra-se em uso por outro usuário, verifique ou informe o administrador do sistema";
            case "auth/weak-password": return "Senha deve ter no mínimo 6 caracteres";
            case "auth/invalid-email": return "Formato de e-mail inválido";
            case "auth/invalid-password": return "Usuário ou senha inválida, verifique e tente novamente";
            case "auth/invalid-phone-number": return "Número de telefone inválido";
            case "auth/email-already-exists": return "Este e-mail encontra-se em uso por outro usuário, verifique ou informe o administrador do sistema";
            case "auth/id-token-expired": return "Sessão expirada, efetue o login novamente";
            case "auth/id-token-revoked": return "Sessão expirada, efetue o login novamente";
            case "auth/network-request-failed": return "Internet não disponível, verifique sua conexão e tente novamente";
            case "auth/user-not-found": return "Usuário ou senha inválida, verifique e tente novamente";
            case "auth/user-token-expired": return "Sessão expirada, efetue o login novamente";
            case "auth/wrong-password": return "Usuário ou senha inválida, verifique e tente novamente";
            case "auth/too-many-requests": return "Tentativas de login em excesso. Solicite uma nova senha através da função 'Esqueci minha senha'";
            default: return "Erro durante a autenticação, informe o administrador do sistema";
        }
    };


}

const instance = new FirebaseAuthService();

export default instance;